import * as actionTypes from '../../../types/users';
import { getUsersList, getUserConfigsUrl, getUsersTotals } from '../../../../services/endpoints/users';

/**
 * @function
 * @name getUserConfigs
 * @description Конфигурация страницы
 */
export const getUserConfigs = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_CONFIG });

  try {
    const response = await getUserConfigsUrl();
    const { data } = response;

    dispatch({
      type: actionTypes.GET_CONFIG_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    dispatch({ type: actionTypes.GET_CONFIG_ERROR, error });
  }
};

/**
 * @function
 * @name getUsersListAction
 * @description Листинг страницы
 * @param {object} payload - Объект query листинга(фильтров)
 */
export const getUsersListAction = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_LIST });

  try {
    const response = await getUsersList(payload);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_LIST_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    dispatch({
      type: actionTypes.GET_LIST_ERROR,
      error,
    });
  }
};

/**
 * @function
 * @name getUsersTotals
 */
export const getUsersTotalsAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_TOTALS });

  try {
    const response = await getUsersTotals();
    const { data } = response;

    dispatch({
      type: actionTypes.GET_TOTALS_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    dispatch({ type: actionTypes.GET_TOTALS_ERROR, error });
  }
};
